const startpoint = "https://backend.tgcgroup.kz/admin/"
const mediapoint = "https://backend.tgcgroup.kz/"
const point = "https://backend.tgcgroup.kz/admin/"

// const startpoint = "http://localhost:8001/admin/"
// const point = "http://localhost:8001/"
// const mediapoint = "http://localhost:8001/"

export { startpoint, mediapoint, point }
